export const iconFontAwesomeMedicalHealthVirusCovidSlash = (
	<i className="fa-solid fa-virus-covid-slash"></i>
);
